import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { GetUserProfileData } from "@/types/userProfile";

import { getUserProfileApi } from "./userProfileApi";

export const useGetUserProfileAPI = (
  options?: Omit<
    UseQueryOptions<GetUserProfileData, Error, GetUserProfileData>,
    "queryKey" | "queryFn"
  >,
  queryOrigin?: "auth" | "userProfile"
) =>
  useQuery({
    queryKey: ["getUserProfile", queryOrigin ?? "userProfile"],
    queryFn: getUserProfileApi,
    ...options
  });
